function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Accounting, IntegrationStatus } from "../../types/api.model";
export class AccountingIntegrationModel {
  static fromQBO(dto) {
    return new AccountingIntegrationModel(_objectSpread({
      id: dto.id,
      companyId: dto.id,
      status: dto.status,
      source: dto.source
    }, dto.qbo ? {
      companyName: dto.qbo.companyName,
      linkUrl: dto.qbo.linkUrl,
      isReady: dto.qbo.isReady,
      settings: dto.qbo.settings,
      qboSettings: dto.qbo.qboSettings,
      accounts: dto.qbo.accounts,
      multipleAccountsConnected: dto.qbo.multipleAccountsConnected
    } : {
      companyName: '',
      linkUrl: '',
      isReady: false,
      settings: {
        accounting: Accounting.QBO,
        automaticInvoicesSync: false,
        classTrackingAgreementOverride: false,
        displayBillableTimeActivities: false
      },
      qboSettings: {
        customTxnNumbers: false
      },
      accounts: {},
      multipleAccountsConnected: false
    }));
  }
  static fromXero(dto) {
    return new AccountingIntegrationModel(_objectSpread({
      id: dto.id,
      status: dto.status,
      source: dto.source
    }, dto.xero ? {
      companyName: dto.xero.companyName,
      isReady: dto.xero.isReady,
      settings: dto.xero.settings,
      accounts: dto.xero.accounts,
      multipleAccountsConnected: dto.xero.multipleAccountsConnected
    } : {
      companyName: '',
      isReady: false,
      settings: {
        accounting: Accounting.Xero,
        automaticInvoicesSync: false
      },
      accounts: {},
      multipleAccountsConnected: false
    }));
  }
  constructor(data) {
    this.data = data;
  }
  get source() {
    return this.data.source;
  }
  get status() {
    return this.data.status;
  }
  toXeroDTO() {
    return this.data.status === IntegrationStatus.Linked ? {
      id: this.data.id,
      status: IntegrationStatus.Linked,
      source: Accounting.Xero,
      xero: {
        companyName: this.data.companyName,
        isReady: this.data.isReady,
        settings: _objectSpread({}, this.data.settings),
        accounts: this.data.accounts,
        multipleAccountsConnected: this.data.multipleAccountsConnected
      }
    } : {
      id: this.data.id,
      status: this.data.status,
      source: Accounting.Xero
    };
  }
  toQboDTO() {
    if (this.data.status === IntegrationStatus.Linked) {
      var _this$data$qboSetting;
      return {
        id: this.data.id,
        status: IntegrationStatus.Linked,
        source: Accounting.QBO,
        qbo: {
          companyName: this.data.companyName,
          isReady: this.data.isReady,
          settings: {
            automaticInvoicesSync: this.automaticInvoicesSync(),
            classTrackingAgreementOverride: this.classTrackingAgreementOverride(),
            displayBillableTimeActivities: this.displayBillableTimeActivities()
          },
          qboSettings: {
            customTxnNumbers: this.data.source === Accounting.QBO ? (_this$data$qboSetting = this.data.qboSettings) === null || _this$data$qboSetting === void 0 ? void 0 : _this$data$qboSetting.customTxnNumbers : false
          },
          accounts: this.data.accounts,
          multipleAccountsConnected: this.data.multipleAccountsConnected
        }
      };
    } else {
      return {
        id: this.data.id,
        status: this.data.status,
        source: Accounting.QBO
      };
    }
  }
  toQBOIntegration() {
    if (this.data.status === IntegrationStatus.Linked) {
      var _this$data$qboSetting2;
      return {
        id: this.data.id,
        status: IntegrationStatus.Linked,
        source: Accounting.QBO,
        companyName: this.data.companyName,
        companyId: this.data.id,
        linkUrl: this.linkUrl(),
        isReady: this.data.isReady,
        settings: {
          automaticInvoicesSync: this.automaticInvoicesSync(),
          classTrackingAgreementOverride: this.classTrackingAgreementOverride(),
          displayBillableTimeActivities: this.displayBillableTimeActivities()
        },
        qboSettings: {
          customTxnNumbers: this.data.source === Accounting.QBO ? (_this$data$qboSetting2 = this.data.qboSettings) === null || _this$data$qboSetting2 === void 0 ? void 0 : _this$data$qboSetting2.customTxnNumbers : false
        },
        accounts: this.data.accounts,
        multipleAccountsConnected: this.data.multipleAccountsConnected
      };
    } else {
      return {
        id: this.data.id,
        status: this.data.status,
        source: Accounting.QBO,
        companyName: '',
        companyId: '',
        isReady: false,
        settings: {
          automaticInvoicesSync: false,
          classTrackingAgreementOverride: false,
          displayBillableTimeActivities: false
        },
        qboSettings: {
          customTxnNumbers: false
        },
        accounts: {},
        multipleAccountsConnected: false
      };
    }
  }
  isLinked() {
    return this.status === IntegrationStatus.Linked;
  }
  getLinkUrl() {
    if (this.data.source === Accounting.QBO) {
      var _this$data$linkUrl;
      return (_this$data$linkUrl = this.data.linkUrl) !== null && _this$data$linkUrl !== void 0 ? _this$data$linkUrl : '';
    }
    return '';
  }
  settings() {
    return this.data.settings;
  }
  isPendingAccountingIntegrationSetup() {
    const accountsList = Object.values(this.data.accounts);
    const isValidAccountsLength = accountsList.length === 3;
    const areAllAccountsSynced = accountsList.every(account => Boolean(account.synced));
    return !isValidAccountsLength || !areAllAccountsSynced;
  }
  displayBillableTimeActivities() {
    switch (this.data.source) {
      case Accounting.QBO:
        return this.data.settings.displayBillableTimeActivities;
      case Accounting.Xero:
        return false;
    }
  }
  classTrackingAgreementOverride() {
    switch (this.data.source) {
      case Accounting.QBO:
        return this.data.settings.classTrackingAgreementOverride;
      case Accounting.Xero:
        return false;
    }
  }
  linkUrl() {
    var _this$data$linkUrl2;
    switch (this.data.source) {
      case Accounting.QBO:
        return (_this$data$linkUrl2 = this.data.linkUrl) !== null && _this$data$linkUrl2 !== void 0 ? _this$data$linkUrl2 : '';
      case Accounting.Xero:
        return '';
    }
  }
  automaticInvoicesSync() {
    return this.data.settings.automaticInvoicesSync;
  }
  isReady() {
    return this.data.isReady;
  }
  companyName() {
    return this.data.companyName;
  }
  isMultipleAccountsConnected() {
    return this.data.multipleAccountsConnected;
  }
  getClearingAccountId() {
    var _this$data$accounts$c, _this$data$accounts$c2;
    return (_this$data$accounts$c = (_this$data$accounts$c2 = this.data.accounts.clearing) === null || _this$data$accounts$c2 === void 0 || (_this$data$accounts$c2 = _this$data$accounts$c2.synced) === null || _this$data$accounts$c2 === void 0 ? void 0 : _this$data$accounts$c2.integratedId) !== null && _this$data$accounts$c !== void 0 ? _this$data$accounts$c : undefined;
  }
  getBankAccountId() {
    var _this$data$accounts$b, _this$data$accounts$b2;
    return (_this$data$accounts$b = (_this$data$accounts$b2 = this.data.accounts.bank) === null || _this$data$accounts$b2 === void 0 || (_this$data$accounts$b2 = _this$data$accounts$b2.synced) === null || _this$data$accounts$b2 === void 0 ? void 0 : _this$data$accounts$b2.integratedId) !== null && _this$data$accounts$b !== void 0 ? _this$data$accounts$b : undefined;
  }
  getExpenseAccountId() {
    var _this$data$accounts$e, _this$data$accounts$e2;
    return (_this$data$accounts$e = (_this$data$accounts$e2 = this.data.accounts.expense) === null || _this$data$accounts$e2 === void 0 || (_this$data$accounts$e2 = _this$data$accounts$e2.synced) === null || _this$data$accounts$e2 === void 0 ? void 0 : _this$data$accounts$e2.integratedId) !== null && _this$data$accounts$e !== void 0 ? _this$data$accounts$e : undefined;
  }
  isErrored() {
    return this.status === IntegrationStatus.Error;
  }
  setClassTrackingAgreementOverride(classTrackingAgreementOverride) {
    switch (this.data.source) {
      case Accounting.QBO:
        return new AccountingIntegrationModel(_objectSpread(_objectSpread({}, this.data), {}, {
          settings: _objectSpread(_objectSpread({}, this.data.settings), {}, {
            classTrackingAgreementOverride
          })
        }));
      case Accounting.Xero:
        return this;
    }
  }
  setDisplayBillableTimeActivities(displayBillableTimeActivities) {
    switch (this.data.source) {
      case Accounting.QBO:
        return new AccountingIntegrationModel(_objectSpread(_objectSpread({}, this.data), {}, {
          settings: _objectSpread(_objectSpread({}, this.data.settings), {}, {
            displayBillableTimeActivities
          })
        }));
      case Accounting.Xero:
        return this;
    }
  }
  setAutomaticInvoicesSync(automaticInvoicesSync) {
    switch (this.data.source) {
      case Accounting.QBO:
        return new AccountingIntegrationModel(_objectSpread(_objectSpread({}, this.data), {}, {
          settings: _objectSpread(_objectSpread({}, this.data.settings), {}, {
            automaticInvoicesSync
          })
        }));
      case Accounting.Xero:
        return new AccountingIntegrationModel(_objectSpread(_objectSpread({}, this.data), {}, {
          settings: _objectSpread(_objectSpread({}, this.data.settings), {}, {
            automaticInvoicesSync
          })
        }));
    }
  }
  settingValue(id) {
    return this.data.settings[id] || false;
  }
}